import { ExtOperStatus, SortOrder } from '../../types';
import { DataState } from '../../types/asyncData';
import { SowChangeReqFullDto } from '../../types/sow-change-req';
import { recentSowChangesStoreKey } from './recentSowChanges.const';

export interface ExtOperationStatusDto {
  action: string;
  status: ExtOperStatus;
}

export interface RecentSOWChangesState {
  currentPage: number;
  totalPages: number;
  data: SowChangeReqFullDto[];

  pageSize: number;
  reportData: SowChangeReqFullDto[];
  isLoading: DataState;
  isReportLoading: DataState;
  cache: { [key: string]: SowChangeReqFullDto[] };
  executeSowChangeReqState: DataState;
  executeSowChangeReqError: string | null;

  rejectSowChangeReqState: DataState;
  rejectSowChangeReqError: string | null;

  sowChangeReqId: string | null;

  filters: { [key: string]: string[] };
  areFiltersApplied: boolean;
  sortBy: SortRecentOperationalChangesBy;
  sortOrder: SortOrder;
}
export interface AppStateWithRecentSOWChangesData {
  [recentSowChangesStoreKey]: RecentSOWChangesState;
}

export enum ChangesTypesEnum {
  MOVE_RESOURCE = 'Project',
  EDIT_RESOURCE = 'Edit resource',
}

export enum RequestType {
  FETCH = 'FETCH',
  DOWNLOAD = 'DOWNLOAD',
}

export interface FetchRecentOperationalChangesPayload {
  currentPage: number;
  limit: number;
  authorIds: string[];
  reviewerIds: string[];
  actions: string[];
  userIds: string[];
  accountIds: string[];
  projectIds: string[];
  reqStatus: string[];
  fromDate: string | null;
  toDate: string | null;
  requestType: RequestType;
  sortBy: SortRecentOperationalChangesBy;
  sortOrder: string;
}

export interface ChangedEntry {
  valueChanged: string;
  oldValue: string;
  newValue: string;
}

export const EDIT_RESOURCE_CHANGE_FIELD_LABELS = {
  seniority: 'Seniority',
  position: 'Position',
  billRate: 'Bill rate',
  project: 'Project',
  allocation: 'Allocation',
  startedAt: 'Start date',
  endedAt: 'End date',
};

export const recentChangesTypes = [
  'Project',
  'Allocation',
  'Start date',
  'End date',
  'Position',
  'Bill rate',
  'Seniority',
];

export const ExtOperStatusLabel = {
  [ExtOperStatus.SUCCESS]: 'Success',
  [ExtOperStatus.INTERNAL_ERROR]: 'Internal error',
  [ExtOperStatus.NO_OLD_OR_NEW_PROJECT]: 'No old or new project',
  [ExtOperStatus.NO_EMPTY_SLOT]: 'No empty slot',
};
export enum SortRecentOperationalChangesBy {
  Date = 'createdAt',
  User = 'user',
  Accounts = 'accounts',
  Projects = 'projects',
  Author = 'author',
  Reviewer = 'reviewer',
}

export const sortableColumns: Record<string, SortRecentOperationalChangesBy> = {
  Accounts: SortRecentOperationalChangesBy.Accounts,
  Projects: SortRecentOperationalChangesBy.Projects,
  Date: SortRecentOperationalChangesBy.Date,
  User: SortRecentOperationalChangesBy.User,
  Author: SortRecentOperationalChangesBy.Author,
  Reviewer: SortRecentOperationalChangesBy.Reviewer,
};
export interface RecentOperationalChangesSortPayloadType {
  sortBy: SortRecentOperationalChangesBy;
  sortOrder?: SortOrder;
}
